import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '../store';

const C = {
  bg:"#0A0E1A",card:"#0D1526",surface:"#111827",
  accent:"#00D4AA",gold:"#F59E0B",border:"#1e2d45",
  text:"#E8EDF5",muted:"#6b7fa3",navy:"#003366"
};

export default function ChannelAnalyticsPage() {
  const navigate = useNavigate();
  const { channelId } = useParams();
  const { token } = useAuthStore();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`/api/messages/channels/${channelId}/analytics`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(r => r.json())
    .then(d => {
      if (d.success) setData(d.data);
      else setError(d.error);
    })
    .catch(() => setError("Erreur réseau"))
    .finally(() => setLoading(false));
  }, [channelId]);

  if (loading) return (
    <div style={{background:C.bg,position:"fixed",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{color:C.accent,fontSize:16}}>Chargement analytics...</div>
    </div>
  );

  return (
    <div style={{fontFamily:"sans-serif",background:C.bg,color:C.text,position:"fixed",inset:0,overflowY:"auto"}}>
      <div style={{position:"sticky",top:0,zIndex:100,background:C.bg,borderBottom:`1px solid ${C.border}`,padding:"14px 20px",display:"flex",alignItems:"center",gap:12}}>
        <button onClick={()=>navigate(-1)} style={{background:"none",border:"none",color:C.accent,fontSize:24,cursor:"pointer"}}>&#8249;</button>
        <div style={{flex:1}}>
          <div style={{fontSize:16,fontWeight:700}}>Analytics du canal</div>
          {data?.canal?.is_verified && <div style={{fontSize:12,color:C.accent}}>✓ Canal vérifié — {data.canal.plan}</div>}
        </div>
      </div>

      <div style={{padding:"20px"}}>
        {error ? (
          <div style={{background:"#FF4F6A22",border:"1px solid #FF4F6A44",borderRadius:14,padding:20,textAlign:"center"}}>
            <div style={{fontSize:16,color:"#FF4F6A",marginBottom:8}}>⚠️ {error}</div>
            {error.includes("abonnement") && (
              <button onClick={()=>navigate("/verified-channel")}
                style={{background:C.accent,border:"none",borderRadius:10,padding:"10px 20px",color:"#000",fontSize:14,fontWeight:700,cursor:"pointer",marginTop:8}}>
                Obtenir le badge ✓
              </button>
            )}
          </div>
        ) : data ? (
          <>
            {/* Stats abonnés */}
            <div style={{fontSize:16,fontWeight:700,marginBottom:12}}>📊 Abonnés</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
              {[
                {label:"Total",value:data.abonnes?.total||0,color:C.accent},
                {label:"7 derniers jours",value:"+"+( data.abonnes?.new_7j||0),color:C.gold},
                {label:"30 derniers jours",value:"+"+( data.abonnes?.new_30j||0),color:"#E879F9"},
              ].map((s,i)=>(
                <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:12,textAlign:"center"}}>
                  <div style={{fontSize:22,fontWeight:700,color:s.color}}>{s.value}</div>
                  <div style={{fontSize:10,color:C.muted,marginTop:4}}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Stats messages */}
            <div style={{fontSize:16,fontWeight:700,marginBottom:12}}>💬 Publications</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
              {[
                {label:"Total",value:data.messages?.total_messages||0,color:C.accent},
                {label:"7 derniers jours",value:data.messages?.messages_7j||0,color:C.gold},
                {label:"30 derniers jours",value:data.messages?.messages_30j||0,color:"#E879F9"},
              ].map((s,i)=>(
                <div key={i} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:12,padding:12,textAlign:"center"}}>
                  <div style={{fontSize:22,fontWeight:700,color:s.color}}>{s.value}</div>
                  <div style={{fontSize:10,color:C.muted,marginTop:4}}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Croissance hebdo */}
            {data.croissance_hebdo?.length > 0 && (
              <>
                <div style={{fontSize:16,fontWeight:700,marginBottom:12}}>📈 Croissance hebdomadaire</div>
                <div style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:20}}>
                  {data.croissance_hebdo.map((s,i)=>(
                    <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:i<data.croissance_hebdo.length-1?`1px solid ${C.border}`:"none"}}>
                      <span style={{fontSize:13,color:C.muted}}>
                        Semaine du {new Date(s.semaine).toLocaleDateString("fr-FR")}
                      </span>
                      <span style={{fontSize:14,fontWeight:700,color:C.accent}}>+{s.nouveaux} abonnés</span>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Infos abonnement */}
            <div style={{background:C.navy,borderRadius:14,padding:16}}>
              <div style={{fontSize:14,fontWeight:700,color:C.accent,marginBottom:8}}>✓ Abonnement Vérifié</div>
              <div style={{fontSize:13,color:"#8899bb"}}>
                Plan : <strong style={{color:C.text}}>{data.canal?.plan}</strong><br/>
                Expire le : <strong style={{color:C.text}}>
                  {data.canal?.expires_at ? new Date(data.canal.expires_at).toLocaleDateString("fr-FR") : "—"}
                </strong>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
